import styled from 'styled-components';

export const Wrapper = styled.div({
  display: 'flex',
  position: 'relative',
});

export const GameControlHeaderWrapper = styled.div({
  width: '100%',
  zIndex: 2,
  pointerEvents: 'none',
});

export const GameContentWrapper = styled.div({
  display: 'flex',
  position: 'relative',
  flex: 1,

  [GameControlHeaderWrapper]: {
    position: 'absolute',
    top: 0,
    left: 0,
  },
});

export const ContentWrapper = styled.div({
  position: 'relative',
  width: '100%',
  height: '100%',
});
